import { render, staticRenderFns } from "./project-view.vue?vue&type=template&id=6453b0e2&scoped=true&"
import script from "./project-view.vue?vue&type=script&lang=js&"
export * from "./project-view.vue?vue&type=script&lang=js&"
import style0 from "./project-view.vue?vue&type=style&index=0&id=6453b0e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6453b0e2",
  null
  
)

export default component.exports